const LegalPage = () => {
  const sections = [
    {
      title: 'Angaben gemäß Impressumspflicht',
      content: `The Flow Company\n\nBaarerstrasse 75\n6300 Zug\nSchweiz`
    },
    {
      title: 'Vertreten durch',
      content: 'Veton Dida'
    },
    {
      title: 'Kontakt',
      content: 'E-Mail: hello@culturecracker.io\nWebsite: culturecracker.io'
    },
    {
      title: 'Handelsregister',
      content: 'UID: CHE-186.180.770\nCH-036.4.071.594-1\nHandelsregister des Kantons Zug'
    },
    {
      title: 'Haftungsausschluss',
      content: 'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.\n\nAls Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.'
    },
    {
      title: 'Urheberrecht',
      content: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem schweizerischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.\n\n© 2026 Culture Cracker® · The Flow Company. Alle Rechte vorbehalten.'
    }
  ];

  return (
    <main className="bg-[var(--bg-primary)] min-h-screen pt-28 sm:pt-32 pb-16 sm:pb-24">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12">
        <p className="eyebrow mb-6">RECHTLICHES</p>
        <h1 className="h1-display text-3xl sm:text-4xl lg:text-5xl mb-16">Impressum</h1>

        <div className="space-y-12">
          {sections.map((section, i) => (
            <div key={i}>
              <h2 className="h3-display text-xl mb-4">{section.title}</h2>
              <div className="body-md whitespace-pre-line leading-relaxed">{section.content}</div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default LegalPage;
